/* global axios */
import ApiClient from './ApiClient';

class InboxNotificationPreferences extends ApiClient {
  constructor() {
    super('inbox_notification_preferences', { accountScoped: true });
  }

  update(params) {
    return axios.patch(`${this.url}`, params);
  }
}

export default new InboxNotificationPreferences();
